import { routeCreator } from '@adrias-online/steiner/lib/helpers';
import _ from 'lodash';

import routeRegister from '../../../helpers/routeRegister';
import { generateRoutes } from '../../../helpers/hotelModuleHelper';
import { selectors } from '../reducers/hotelConfig';

const routes = generateRoutes('hotelConfig', selectors);
const list = _.values(routes.list).map((route) => ({
    ...route,
    hotelFilter: true,
    getComponent() {
        return new Promise((resolve) => {
            import(
                /* webpackChunkName: 'hotelConfig' */ `modules/hotelConfig/${route.componentPath}`
            ).then((response) => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('hotelConfig', routes.patterns);
routeRegister.addLinks('hotelConfig', links);

export default list;
